import {CashChargeInfo} from './CashChargeInfo.interface';
import {HelixConversionInfo} from './HelixConversionInfo.interface';
import {TrackEventObject} from './TrackEventObject.interface';
import {ViewerConversionInfo} from './ViewerConversionInfo.interface';

/**
 * 직전 단계 로그 정보와 열람 로그 등을 판단할 때 필요
 * XXX: 새로고침하면 날아갈 값이라 사이즈 이슈 없을것이라 판단해 slice 없이 모두 넣음
 */
export const prevEvents: TrackEventObject[] = [];

export const currentEventContext: {
  /**
   * 마지막에 남긴 pageView 이벤트
   */
  currentPageView?: TrackEventObject;
  viewerConversionInfo?: ViewerConversionInfo;
  helixConversionInfo?: HelixConversionInfo;
  cashChargeInfo?: CashChargeInfo;
} = {
  currentPageView: undefined,
  viewerConversionInfo: undefined,
  helixConversionInfo: undefined,
  cashChargeInfo: undefined,
};

export const currentSearchActionEventContext: {
  lastSearchType?: string;
} = {
  lastSearchType: undefined,
};
